module.exports = __webpack_public_path__ + "img/59.end_clean_zone.fe98da01.svg";